import { FunctionComponent, useMemo } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import { Image } from '@utils/cook/types'
import FreeRatioImage from '@components/FreeRatioImage'
import { ImageConstraints } from '@components/FreeRatioImage/types'

export interface LogosImageProps {
  image: Image<'free'>
  className?: string
}

const MAX_HEIGHT = 48

const LogosImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: ${MAX_HEIGHT}px;

  ${desktopCSS(css`
    height: ${MAX_HEIGHT}px;
  `)}
`

const LogosImage: FunctionComponent<LogosImageProps> = ({
  className,
  image,
}) => {
  const constraints = useMemo<ImageConstraints>(
    () => ({
      desktop: {
        width: image.width,
        height: MAX_HEIGHT,
      },
      tablet: {
        width: image.width,
        height: MAX_HEIGHT,
      },
      mobile: {
        width: image.width,
        height: MAX_HEIGHT,
      },
      mobileSmall: {
        width: image.width,
        height: MAX_HEIGHT,
      },
    }),
    [image.width]
  )

  return (
    <LogosImageContainer>
      {image ? (
        <FreeRatioImage
          className={className}
          src={image.src}
          alt={image.alt}
          crops={image.crops ?? {}}
          originalDimensions={{
            width: image.width,
            height: image.height,
          }}
          constraints={constraints}
        />
      ) : null}
    </LogosImageContainer>
  )
}

export default LogosImage
